import { OrderFilters } from "@/types";

export const ORDER_KEY = "ORDER";

export const ORDER_CACHE_KEYS = {
  LIST: (filters: OrderFilters) => [ORDER_KEY, "LIST", filters] as const,
  GET: (id: string) => [ORDER_KEY, "GET", id] as const,
  ATTRIBUTION_OPTIONS: [ORDER_KEY, "ATTRIBUTION_OPTIONS"] as const,
};
